var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-select-box',{ref:"selectBox",attrs:{"value":_vm.value,"search-enabled":true,"data-source":_vm.options,"display-expr":_vm.label,"value-expr":_vm.code,"height":_vm.height},on:{"value-changed":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }